<template>
	<div class="form-container-80">
		<form method="POST" :action="action" @submit.prevent="onSubmit">
			<div class="columns is-vcentered is-gapless is-centered register-page">
				<div class="column is-1">
					<div class="has-background-warning radius-lg-right card p20 hovered-container-desktop">
						<div class="before-hover has-text-white has-text-weight-bold">
							<p>
								{{t('not_registred')}}

							</p>
						</div>
						<div class="after-hover height-full w-100">
							<div class="display-table height-full w-100">
								<div class="display-table-cell vertical-align has-text-centered">
								    <i class="icon_client has-text-white reg-icon"></i>
									<p class="has-text-white has-text-weight-bold mb20 mt20">{{t('dont_have_account')}}</p>
									<a rel="noreferrer" :href="`/${this.sitelocale}/register`" class="button btn-white has-text-warning hvr-shutter-out-vertical hvr-primary is-rounded p25 min-w-150 has-text-weight-bold"><span>{{t('register')}}</span></a>
								</div>
							</div>
						</div>
					</div>
					<div class="has-background-warning radius-lg-right card p20 hovered-container-mobile">
						<a rel="noreferrer" :href="`/${this.sitelocale}/register`" class="before-hover has-text-white has-text-weight-bold is-block">
							<p class="has-text-centered">
								{{t('not_registred')}}
							</p>
						</a>
					</div>
				</div>
				<div class="column is-6 mt30-mobile">
					<div class="has-background-white card p20">
						<h3 class="has-text-weight-bold has-text-primary has-text-centered is-size-6 mb30">{{t('login')}}</h3>
						<div class="pr30 pl30 mt100">
							<div class="field mb30">
								<div class="control">
									<input name="email" class="input line-input is-primary has-text-centered" required autocomplete="email" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" :placeholder="t('email')" >
									<div v-show="errors.has('email')" class="help is-danger has-text-right">{{ errors.first('email') }}</div>
								</div>
							</div>
							<div class="field mb30">
								<div class="control">
									<input name="password" class="input line-input is-primary has-text-centered" v-model="form.password" v-validate="{ required: true , min:6 ,max:255 }" :class="{'is-danger': errors.has('password') }" :type="passwordFieldType" :placeholder="t('password')" ref="password">
									<span v-show="errors.has('password')" class="help is-danger has-text-right">{{ errors.first('password') }}</span>
								</div>
								<div class="has-text-centered">
									<a rel="noreferrer" class="has-text-grey is-size-7" :href="`/${this.sitelocale}/password/reset`">
									{{t('Reset Link')}}
									</a>
								</div>
							</div>
							<div class="field">
								<input class="is-checkradio is-primary form-check-input" :class="[sitelocale == 'ar' ? 'is-rtl' : '']" type="checkbox" name="remember" id="remember" v-model="form.remember">
								<label class="has-text-grey" for="remember">
									{{t('remember_me')}}
								</label>
							</div>
							<div class="field mt90">
								<div class="control has-text-centered">
									<button type="submit" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded pr20 pl20" :disabled='isDisabled'>{{t('login')}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
	import axios from 'axios';
	import trans from '../translation/user.json';
	import { Validator , mapFields} from 'vee-validate';
	import arabic from 'vee-validate/dist/locale/ar';
	export default {
		name: 'Login',
		props: {
			action: {
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
		},
		data(){
			return{
				form : {
					type: 'client',
					email:'',
					password:'',
                    remember:'',
				},
				passwordFieldType: 'password',
				isDisabled:false

			}
		},
		mounted(){
			this.$translate.setLang(this.sitelocale);
		},
		locales: trans,
		created(){
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
				custom:trans.ar.custom
			});
			this.$validator.localize('en', {
				custom:trans.en.custom
			});

			Validator.localize(this.sitelocale);
		},
		methods:{
			onSubmit(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.isDisabled=true
						const action = this.action;
						axios.post(action, this.form)
						.then(response => {
							this.showAlert('success' , `${this.$translate.text('login_successfully')}`  , `${this.$translate.text('welcome')}`+response.data.data.name , '')
							setTimeout(()=>{
							    if (response.data.data.active) {
							        if (response.data.data.role != 'merchant' &&  response.data.data.role != 'client') {
                                        window.location.href = `/${this.sitelocale}/dashboard`;
                                    } else if (response.data.data.role == 'merchant') {
                                        window.location.href = `/${this.sitelocale}/merchant/profile`;
                                    } else {
                                        window.location.href = `/${this.sitelocale}/`;
                                    }
                                } else {
                                    window.location.href = `/${this.sitelocale}/`;
                                }
							}, 2000);

						})
						.catch(error => {
							this.showAlert('error',
								`${this.$translate.text('error_in_data')}`,
								'text',
								`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error[0]}</li>`).join(' ')+`</ul>`
								)
							this.isDisabled=false;
							console.clear();
						})
						.then(()=>{

							setTimeout(()=>{

							}, 3500);
						});

					}

				});

			},
			showAlert(type , title , text , html){
				this.$swal({
					type: type,
					title: title,
					text: text,
					html: html,
					showConfirmButton: false,
					timer:2000,
					customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
					backdrop: `
					rgba(36, 140, 204, 0.5)
					`
				});
			}
		}

	};
</script>

<style lang="scss">

</style>


